export default "__VITE_ASSET__b051a82c__"